import { XMarkIcon } from "@heroicons/react/20/solid";
import { useRef } from "react";
import { FaFileAlt } from "react-icons/fa";
import { IoCloudUploadOutline } from "react-icons/io5";

const FileInput = ({
  label = "",
  file = "",
  onInput = null,
  id = "",
  onRemove = null,
}) => {
  const inputFileRef = useRef(null);

  const removeHandler = () => {
    if (inputFileRef && inputFileRef?.current) {
      inputFileRef.current.value = "";
    }

    if (onRemove) {
      onRemove();
    }
  };

  return (
    <div className="relative w-full h-full rounded-lg border border-gray-400 border-dashed p-2">
      {label && (
        <label className="absolute left-3 bg-white px-1 text-gray-500 -top-3">
          {label || ""}
        </label>
      )}
      <div className="flex gap-3 overflow-x-auto h-full">
        {file && (
          <div className="h-full w-28 border border-gray-500 p-1 rounded-lg flex justify-center items-center relative">
            <FaFileAlt className="size-3/4 font-extralight" strokeWidth={0.5} />
            <button
              type="button"
              className="absolute top-1 right-1 rounded-full border border-white size-5 flex justify-center items-center text-white bg-red-500 hover:scale-105 transition-all duration-500"
              onClick={removeHandler}
            >
              <XMarkIcon className="size-4" />
            </button>
          </div>
        )}
      </div>

      <label
        htmlFor={id}
        className="cursor-pointer px-4 py-2 text-lg absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 flex items-center gap-2 text-gray-500"
      >
        <IoCloudUploadOutline className="size-6" />
        Upload
      </label>

      <input
        type="file"
        className="hidden"
        onInput={onInput}
        id={id}
        ref={inputFileRef}
      />
    </div>
  );
};

export default FileInput;
